/*
 * File: language-button.ts
 * File Created: 2023-11-27 03:21:15
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-24 06:56:34
 * Modified By: Val Liu
 * -----
 */

/// refined at 2023/12/12
import { Component, Prop, Watch } from "vue-property-decorator";
import { BaseComponent } from "@root/components/base-classes";
import { Subscription } from "rxjs";
import { PropInnateSync } from "@root/core/vue-props/prop-innate-sync";

@Component
export default class LanguageButton extends BaseComponent {
    @PropInnateSync("value", { type: String, required: false })
    innateValue!: string | undefined;

    /// synchronize with lang immediately
    @Prop({ type: Boolean, default: () => false })
    sync!: boolean;

    /// watch value
    @Watch("innateValue", { immediate: true })
    onValueChanged(newValue: string) {
        this.$nextTick(() => {
            this.update(newValue);
        });
    }

    /// list all languages
    get list() {
        return this.$lang.list();
    }

    /// update language
    update(name: string) {
        if (name == undefined) return;
        /// catch language not exists error
        try {
            if (this.sync == true) this.$lang.set(name);
        } catch (e) {
            console.log(e);
        }
    }

    /// initial the subscription
    private subsLangChange: Subscription | undefined;
    private created() {
        this.subsLangChange = this.$lang.getObservable().subscribe((name) => {
            // this.update(name, false);
            this.innateValue = name;
        });
    }
    /// recycle the subscription
    private beforeDestroy() {
        this.subsLangChange?.unsubscribe();
    }
}
